export default __webpack_public_path__ + "static/media/28.dda1feb1.svg";